import styles from "./ImageLayoutEven.module.css";
import ImageSlot from "./ImageSlot";

interface Props {
    editing?: boolean;
    images: { [key: string | number]: File | string | null };
    onImageChange?: (key: string | number, newImage: File | null) => void;
}

export default function ImageLayoutEven({
    editing,
    images,
    onImageChange,
}: Props) {
    return (
        <div className={styles.imageContainer}>
            <ImageSlot
                label="Cover Image"
                image={images.cover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("cover", img);
                }}
                editing={editing}
            />
            <ImageSlot
                label="Hover Image"
                image={images.hover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("hover", img);
                }}
                editing={editing}
            />
            <ImageSlot
                image={images[0]}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange(0, img);
                }}
                editing={editing}
            />
            <ImageSlot
                image={images[1]}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange(1, img);
                }}
                editing={editing}
            />
        </div>
    );
}
